const ChangeLog = () => {
  return (
    <div>
        <title>Changelog - Surfwetter</title>
        <div className="App">
            <div className="Content">
                <h1>Changelog</h1>
                <h2>Planned Features</h2>
                <ul>
                    <li>Add custom maximum wind threshold used to highlight lakes and in wind graphs</li>
                    <li>Improve map by adding country outlines</li>
                    <li>Use a topographic map as background</li>
                    <li>Add webcams</li>
                    <li>Add small map of location and various information about each spot</li>
                </ul>
                <h2>[0.2.0] - 01.08.2026</h2>
                <ul>
                    <li>Add selector to display rolling mean or maximum wind in overview</li>
                    <li>Improve mobile stylings</li>
                    <li>Reduced time until new forecast is available by downloading forecast in parallel and processing all stations for each parameter at once instead of sequentially for each paremeter and station.</li>
                    <li>Improved page load time by vastly reducing number of fetch requests (down from 220 to 40)</li>
                </ul>
                <h2>[0.1.9] - 07.05.2026</h2>
                <ul>
                    <li>Dynamically show lake tooltips in overview depending on zoomlevel</li>
                    <li>Fix wrong speed in overview for Sempachersee</li>
                    <li>Add spot Eich on Sempachersee</li>
                </ul>
                <h2>[0.1.8] - 03.05.2026</h2>
                <ul>
                    <li>Add Ägerisee</li>
                    <li>Add Hallwilersee</li>
                    <li>Add Lac du Rosel</li>
                    <li>Add Obersee</li>
                    <li>Add Sempachersee</li>
                    <li>Add Thunersee</li>
                </ul>
                <h2>[0.1.7] - 19.04.2026</h2>
                <ul>
                    <li>Add pressure difference lines</li>
                    <li>Add Bielersee</li>
                </ul>
                <h2>[0.1.6] - 11.04.2026</h2>
                <ul>
                    <li>Add Comersee and Lago Maggiore</li>
                    <li>Impement tabs for lakes with multiple spots</li>
                </ul>
                <h2>[0.1.5] - 06.04.2026</h2>
                <ul>
                    <li>Add water and air temperatur plots</li>
                    <li>Add sunshine and precipitation plots</li>
                </ul>
                <h2>[0.1.4] - 04.01.2026</h2>
                <ul>
                    <li>Add Walensee</li>
                    <li>Add Untersee</li>
                    <li>Add Zugersee</li>
                    <li>Add shape outline for Gardasee</li>
                </ul>
                <h2>[0.1.3] - 29.12.2025</h2>
                <ul>
                    <li>Add clickable lake outlines that change their color depending on the forecasted maximum wind</li>
                    <li>Highlight currently selected day in day selector</li>
                    <li>Add site titles</li>
                    <li>Add changelog</li>
                </ul>
                <h2>[0.1.2] - 21.09.2025</h2>
                <ul>
                    <li>Add clickable tooltips to map indicating maximum wind of each lake for a given day</li>
                    <li>Improve styling of forecast pages and add styles for map</li>
                    <li>Update styles of locations</li>
                    <li>Add Silvaplanersee</li>
                    <li>Add Neuenburgersee</li>
                    <li>Add Impressum</li>
                </ul>
                <h2>[0.1.1] - 10.08.2025</h2>
                <ul>
                    <li>Add main map, footer, and header</li>
                    <li>Update logo</li>
                </ul>
                <h2>[0.1.0] - 09.08.2025</h2>
                <ul>
                    <li>Publish first version of application</li>
                </ul>
            </div>
        </div>
    </div>
  );
};

export default ChangeLog;
